import { SxProps, Theme } from "@mui/material";
import { BLACK, GREEN_LOGO, GREEN_MAIN, WHITE } from "../../../../theme/colors";

// Stili condivisi della sezione Gestione Identity, allineati alla palette verde
// usata dalle altre pagine del pannello amministrazione.

export const titleSx: SxProps<Theme> = {
	color: GREEN_MAIN,
	fontWeight: 700,
};

export const tabsSx: SxProps<Theme> = {
	"& .MuiTab-root": {
		color: GREEN_MAIN,
		opacity: 0.6,
		textTransform: "none",
		fontWeight: 600,
	},
	"& .MuiTab-root.Mui-selected": {
		color: GREEN_MAIN,
		opacity: 1,
	},
	"& .MuiTabs-indicator": {
		backgroundColor: GREEN_MAIN,
	},
};

export const primaryButtonSx: SxProps<Theme> = {
	backgroundColor: GREEN_MAIN,
	color: WHITE,
	textTransform: "none",
	boxShadow: "none",
	"&:hover": { backgroundColor: GREEN_LOGO, boxShadow: "none" },
};

export const outlinedButtonSx: SxProps<Theme> = {
	color: GREEN_MAIN,
	borderColor: GREEN_MAIN,
	textTransform: "none",
	"&:hover": { borderColor: GREEN_LOGO, backgroundColor: `${GREEN_LOGO}14` },
};

export const tableContainerSx: SxProps<Theme> = {
	overflowX: "auto",
	boxShadow: "none",
	border: `1px solid ${GREEN_MAIN}22`,
	borderRadius: "8px",
};

export const headCellSx: SxProps<Theme> = {
	fontWeight: "bold",
	whiteSpace: "nowrap",
	backgroundColor: `${GREEN_MAIN}0D`,
	color: GREEN_MAIN,
	borderBottom: `1px solid ${GREEN_MAIN}22`,
};

export const bodyCellSx: SxProps<Theme> = {
	borderBottom: `1px solid ${GREEN_MAIN}14`,
	color: BLACK,
};

export const roleChipSx: SxProps<Theme> = {
	backgroundColor: `${GREEN_LOGO}1A`,
	color: GREEN_MAIN,
	fontWeight: 500,
	border: `1px solid ${GREEN_LOGO}33`,
};

export const searchFieldSx: SxProps<Theme> = {
	minWidth: 320,
	"& .MuiOutlinedInput-root": {
		"& fieldset": { borderColor: `${GREEN_MAIN}40` },
		"&:hover fieldset": { borderColor: GREEN_MAIN },
		"&.Mui-focused fieldset": { borderColor: GREEN_MAIN },
	},
	"& .MuiInputLabel-root.Mui-focused": { color: GREEN_MAIN },
};
